"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = require("../../index");
var prop_types_1 = __importDefault(require("prop-types"));
function Permission(_a) {
    var permission = _a.permission, role = _a.role, updateRoleSubmit = _a.updateRoleSubmit, setUpdateRole = _a.setUpdateRole, updateRole = _a.updateRole;
    if (!role.permissions) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    function changePermissions(value, permission) {
        var newPermissions = updateRole.data.permissions.clone();
        if (!value) {
            newPermissions = newPermissions.delete(permission.id, 'id');
        }
        else {
            newPermissions = newPermissions.save(permission);
        }
        updateRoleSubmit({ permissions: newPermissions })
            .then(function () { return setUpdateRole({ permissions: newPermissions }); })
            .catch(function (err) { return console.log(err); });
    }
    return react_1.default.createElement("div", { className: 'storybook-roles-dropdown-item bg-white px-4 py-2 border-gray-300 flex items-center' },
        react_1.default.createElement("div", null, permission.name),
        react_1.default.createElement("div", { className: 'ml-auto' },
            react_1.default.createElement(index_1.Forms.Checkbox, { checked: Boolean(updateRole.data.permissions.findBy('id', permission.id).id), onChange: function (value) { return changePermissions(value, permission); } })));
}
exports.default = Permission;
Permission.propTypes = {
    /**
     * Permission object
     */
    permission: prop_types_1.default.object,
    /**
     * Role object
     */
    role: prop_types_1.default.object,
    /**
     * updateRoleSubmit function
     */
    updateRoleSubmit: prop_types_1.default.func,
    /**
     * setUpdateRole function
     */
    setUpdateRole: prop_types_1.default.func,
    /**
     * updateRole object
     */
    updateRole: prop_types_1.default.object,
};
Permission.defaultProps = {};
